import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Router from './router';
import { materialTheme } from './theme/muiTheme';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/core/styles';

const ApplicationRouter = () => {
  return (
    <BrowserRouter basename={window.env.BASE_URL}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <ThemeProvider theme={materialTheme}>
          <Router />
        </ThemeProvider>
      </MuiPickersUtilsProvider>
    </BrowserRouter>
  );
};
export default ApplicationRouter;
